import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IWarningBarState } from 'redux-state/header-warning-bar/types.js';

const initialState: IWarningBarState = {
  colourClass: undefined,
};

export const headerWarningsSlice = createSlice({
  name: 'headerWarnings',
  initialState,
  reducers: {
    REDUX_HEADER_WARNINGS_BAR_UPDATE: (state, action: PayloadAction<IWarningBarState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { REDUX_HEADER_WARNINGS_BAR_UPDATE } = headerWarningsSlice.actions;

export const headerWarningReducer = headerWarningsSlice.reducer;
